<template>
  <div>
    <v-row>
      <v-col cols="12" md="4">
        <phone-input
          v-model="form.mobile_phone"
          name="mobile"
          :label="$t('EMPLOYEES.MOBILE_PHONE')"
          :readonly="readonly"
          :rules="getRulesByName('mobile_phone')"
          :error-messages="errors.mobile_phone"
          @input="updateValue('mobile_phone', $event)"
        ></phone-input>
      </v-col>
      <v-col cols="12" md="4">
        <phone-input
          v-model="form.phone"
          name="phone"
          :label="$t('EMPLOYEES.PHONE')"
          :rules="getRulesByName('phone')"
          :readonly="readonly"
          :error-messages="errors.phone"
          @input="updateValue('phone', $event)"
        ></phone-input>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="form.email"
          name="email"
          :label="$t('EMPLOYEES.EMAIL')"
          :readonly="readonly"
          :rules="getRulesByName('email')"
          :error-messages="errors.email"
          @input="updateValue('email', $event)"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-textarea
          v-model="form.info"
          name="info"
          :label="$t('EMPLOYEES.ADDITIONAL_INFORMATION')"
          :counter="1000"
          :readonly="readonly"
          :rules="getRulesByName('info')"
          :error-messages="errors.info"
          @input="updateValue('info', $event)"
        ></v-textarea>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mask } from 'vue-the-mask';
import formEditable from '@/modules/_global/mixins/form-editable';
import {
  email,
  maxLength,
  maxLengthMaskedPhone
} from '@/modules/_global/variables/rules';

export default {
  name: 'EmployeeContactInformationForm',

  directives: {
    mask
  },

  components: {
    PhoneInput: () => import('@/modules/_global/_components/phone/PhoneInput')
  },

  mixins: [formEditable],

  data() {
    return {
      form: {
        mobile_phone: '',
        phone: '',
        email: '',
        info: ''
      },
      rules: {
        mobile_phone: [maxLengthMaskedPhone(12)],
        phone: [maxLengthMaskedPhone(12)],
        email: email,
        info: [maxLength(1000)]
      }
    };
  }
};
</script>
